import React from "react";
import { RiUser3Line } from "@remixicon/react";

type IconType =
  | React.ComponentType<{ size?: string | number; className?: string }>
  | string
  | undefined;

type DashboardFieldIconProps = {
  icon: IconType;
};

const iconClassName = "text-gray-400 text-[20px] flex-shrink-0";

export default function DashboardFieldIcon({ icon }: DashboardFieldIconProps) {
  if (typeof icon === "string") {
    return <i className={`${icon} ${iconClassName}`}></i>;
  }

  if (icon) {
    const IconComponent = icon;
    return <IconComponent size={20} className={iconClassName} />;
  }

  return <RiUser3Line size={20} className={iconClassName} />;
}

